const emissionsPageDataAr = {
    title : "الطاقة والانبعاثات",
    paraghraphOne : "ولدعم هدف الوصول إلى صافي انبعاثات صفرية في عمليات البنك التشغيلية بحلول العام 2035، تشمل مبادرات الأول للحد من استهلاك الطاقة استبدال الشاشات القديمة بشاشات الكريستال السائل LCD، وتركيب مستشعرات ضوئية لضمان إطفاء جميع الأضواء بعد ساعات العمل. كما تم توصيل جميع مصابيح البنك بأجهزة توقيت ضمن نظام إدارة المبنى للمساعدة في تقليل استخدام الكهرباء. وتساهم المواد المعاد تدويرها المستخدمة في الأرضيات، إلى جانب الجدران ذات العزل القوي، في تقليل التبادل الحراري بين الداخل والخارج لتقليل الحاجة إلى مكيفات الهواء.",
    paraghraphTwo : "وأجرينا في عام 2022 دراسة شاملة لجميع جوانب استهلاك الطاقة في البنك عن العام 2021. وكانت هذه المعلومات بمثابة كشف كامل عن بيانات انبعاثات غازات الدفيئة الخاصة بنا. وعلى الرغم من ذلك، لا يستند بنك الأول إلى بيانات عام 2021 على اعتبارها خط أساس نظراً لتفشي جائحة كوفيد-19 وتأثيرها على العمليات التجارية خلال ذلك العام، وسيُجري البنك تحليلاً دقيقاً لبيانات الطاقة للعام 2022 لتكون بمثابة خط أساس أكثر دقة يساعد في تتبع وقياس التقدم المحرز لتحقيق أهدافه.",
    sectionOne : {
        title : "استهلاك الطاقة",
        table : {
            headers : ["القياس", "2021", "2022"],
            data : [
                {
                    title : "المساحة الكلية للمكتب الرئيسي لبنك الأول ",
                    measure : "متر مربع",
                    2021 : "114,613",
                    2022 : "*114,613",
                },
                {
                    title : "إجمالي استهلاك الكهرباء",
                    measure : "kWh",
                    2021 : "39,349,384",
                    2022 : "34,941,966",
                },
            ]
        },
        gridOne : [
            {
                spanOne : "2021",
                number : 95074,
                spanTwo : "metre2",
                text : "",
            },
            {
                spanOne : "2022",
                number : 95074,
                spanTwo : "metre2",
                text : "",
            },
            {
                spanOne : "",
                spanTwo : "",
                number : null,
                text : "Total space SAB’s main office buildings"
            }
        ],
        gridTwo : [
            {
                spanOne : "2021",
                number : 35872923,
                spanTwo : "kWh",
                text : "",
            },
            {
                spanOne : "2022",
                number : 27796691,
                spanTwo : "kWh",
                text : "",
            },
            {
                spanOne : "",
                spanTwo : "",
                number : null,
                text : "Total electricity consumption"
            }
        ]
    },
    sectionTwo : {
        title : "انبعاثات الغازات الدفيئة",
        subtitle : "في عام 2022، أجرى بنك الأول تحليلاً معيارياً لانبعاثات غازات الدفيئة في عام 2021. يوضح الرسم البياني التالي عناصر الغازات الدفيئة ذات صلة بالبنك:",
        image : "plan-one-ar.svg",
    },
    sectionThree : {
        description : "يدرك البنك أن أكبر تأثيراته على البيئة هو من خلال انبعاثاته الممولة. إلا أن فهم انبعاثات غازات الدفيئة وشدتها داخل محفظة المشاريع التي يمولها البنك يعد عملية معقدة تتطلب تحصيل بيانات مفصلة من عملائنا. ويعتزم البنك إجراء مراجعة شاملة وتحديد خط أساس لقياس الانبعاثات الممولة خلال السنة التقويمية القادمة. في الوقت الراهن، لم يتم تضمين الانبعاثات الممولة في الدراسة الأولية.",   
        labels : [
            [
                {
                    size : '10',
                    subtitle : "2021"
                },
                {
                    size : '40',
                    number : 384,
                    unit : <span>طن من مكافئ ثاني أكسيد الكربون</span>,
                },
                {
                    size : '40',
                    subtitle : "انبعاثات غازات دفيئة مباشرة (النطاق 1)",
                }
            ],
            [
                {
                    size : "10",
                    subtitle : "2021",
                },
                {
                    size : "40",
                    number : 21200,
                    unit : <span>طن من مكافئ ثاني أكسيد الكربون</span>,
                },
                {
                    size : "40",
                    subtitle : "انبعاثات غازات دفيئة غير مباشرة (النطاق 2)",
                }
            ],
            [
                {
                    size : "10",
                    subtitle : "2021",
                },
                {
                    size : "40",
                    number : 123732,
                    unit : <span>طن من مكافئ ثاني أكسيد الكربون</span>,
                },
                {
                    size : "40",
                    subtitle : "انبعاثات غازات دفيئة غير المباشرة (النطاق 3) باستثناء الإقراض والاستثمارات",
                }
            ],
            [
                {
                    size : "10",
                    subtitle : "2021",
                },
                {
                    size : "40",
                    number : 145316,
                    unit : <span>طن من مكافئ ثاني أكسيد الكربون</span>,
                },
                {
                    size : "40",
                    subtitle : "إجمالي انبعاثات الغازات الدفيئة",
                }
            ],
            [
                {
                    size : "10",
                    subtitle : "2021",
                },
                {
                    size : "40",
                    number : 37.26,
                    unit : <span>طن من مكافئ ثاني أكسيد الكربون</span>,
                },
                {
                    size : "40",
                    subtitle : "كثافة انبعاثات غازات الدفيئة",
                }
            ],
            
        ],
        pargraph : "جاءت السلع والخدمات المشتراة في المرتبة الأولى كأكبر مصدر لانبعاثات البنك الناجمة عن العمليات التشغيلية في عام 2021، وهو أمر شائع بالنسبة لشركات تقديم الخدمات مثل بنك الأول.",
    },
    sectionFour : {
        title : "انبعاثات النطاق 3",
        labels : [
            [
                {
                    size : '25',
                    subtitle : "2021 انبعاثات"
                },
                {
                    size : '20',
                    number : 81531,
                    unit : <span>طن من مكافئ ثاني أكسيد الكربون</span>,
                },
                {
                    size : '20',
                    percentage : "%66",
                },
                {
                    size : '30',
                    subtitle : "السلع والخدمات المشتراة"
                }
            ],
            [
                {
                    size : '25',
                    subtitle : "انبعاثات 2021"
                },
                {
                    size : '20',
                    number : 29621,
                    unit : <span>طن من مكافئ ثاني أكسيد الكربون</span>,
                },
                {
                    size : '20',
                    percentage : "%24",
                },
                {
                    size : '30',
                    subtitle : "السلع الرأسمالية"
                },
            ],
            [
                {
                    size : '25',
                    subtitle : "انبعاثات 2021"
                },
                {
                    size : '20',
                    number : 5480,
                    unit : <span>طن من مكافئ ثاني أكسيد الكربون</span>,
                },
                {
                    size : '20',
                    percentage : "%4",
                },
                {
                    size : '30',
                    subtitle : "تنقل الموظفين"
                },
            ],
            [
                {
                    size : '25',
                    subtitle : "انبعاثات 2021"
                },
                {
                    size : '20',
                    number : 5451,
                    unit : <span>طن من مكافئ ثاني أكسيد الكربون</span>,
                },
                {
                    size : '20',
                    percentage : "%4",
                },
                {
                    size : '30',
                    subtitle : "الأنشطة المتصلة بالوقود والطاقة"
                },
            ],
            [
                {
                    size : '25',
                    subtitle : "انبعاثات 2021"
                },
                {
                    size : '20',
                    number : 1264,
                    unit : <span>طن من مكافئ ثاني أكسيد الكربون</span>,
                },
                {
                    size : '20',
                    percentage : "%1",
                },
                {
                    size : '30',
                    subtitle : "السفر لأغراض العمل"
                },
            ],
            [
                {
                    size : '25',
                    subtitle : "انبعاثات 2021"
                },
                {
                    size : '20',
                    number : 385,
                    unit : <span>طن من مكافئ ثاني أكسيد الكربون</span>,
                },
                {
                    size : '20',
                    percentage : "<%1",
                    // persentageString : 
                },
                {
                    size : '30',
                    subtitle : "النفايات الناتجة عن العمليات"
                },
            ],
            [
                {
                    size : '25',
                    subtitle : "انبعاثات 2021"
                },
                {
                    size : '20',
                    title : "لا ينطبق",
                    // unit : <span>Tonns of CO<sub>2</sub>eq</span>,
                },
                {
                    size : '20',
                    title : "لا ينطبق",
                },
                {
                    size : '30',
                    subtitle : "الفنادق"
                },
            ],
        ]
    },
    sectionFive : {
        boxOne : {
            title : "النفايات",
            subtitle : "يحث البنك خلال رحلة انتقاله إلى بيئة خالية من الورق على الحد من طباعة المراسلات والتقارير المتعلقة بالأعمال التجارية، وخصوصاً تلك التي يمكن الوصول إليها إلكترونياً. وخلال العام الماضي، أطلق البنك برنامجاً لإعادة التدوير في 4 من مبانيه. ويتضمن إطار البرنامج، توفير صناديق النفايات الجافة والرطبة لإعادة تدوير الورق. كما تم تصميم مجموعة من الحلول التكنولوجية الذكية لإعادة التدوير ودمجها في مرافق البنك، وذلك لتجنب إرسالها إلى مكبات النفايات.",
        },
        paragraphOne : "وتشمل النتائج الإيجابية في هذه المبادرات جمع ما يقارب من 340 كيلوغرام من النفايات المعاد تدويرها شهرياً. ويُعد الأول أول بنك في المملكة تمكن من التخلص تماماً من العلب البلاستيكية غير القابلة لإعادة التدوير المُستخدمة لمرة واحدة في جميع مكاتبه، حيث نجحت هذه الجهود في توفير حوالي 2.6 مليون زجاجة بلاستيكية سنوياً بفضل الاعتماد على أجهزة التبريد المزودة بمرشحات لتنقية المياه.",
        paragraphTwo : "بالإضافة إلى ذلك، أطلق البنك في عام 2022 مشروعاً ضخماً لتحويل الوثائق الورقية الموجودة في أرشيف البنك إلى نسخ رقمية، وتمكن البنك من إعادة تدوير 205,000 طن من النفايات عن طريق شريك موثوق في مجال إعادة التدوير. سيواصل البنك بذل الجهود الكبيرة لإدارة مخلفاته بشكل فعال من خلال إعادة تدوريها كلما كان ذلك ممكناً.",
        title : "استهلاك المواد والنفايات*",
        labels : [
            [
                {
                    size : '10',
                    subtitle : "2022",
                },
                {
                    size : '40',
                    number : 368,
                    unit : "طن"
                },
                {
                    size: '40',
                    subtitle : "إجمالي الورق المعاد تدويره"
                }
            ],
            [
                {
                    size : '10',
                    subtitle : "2022",
                },
                {
                    size : '40',
                    number : 374926,
                    unit : "كيلوغرام"
                },
                {
                    size : '40',
                    subtitle : "إجمالي النفايات الناتجة"
                }
            ],
        ],
        note : "*بدأ بنك الأول في جمع بيانات النفايات في عام 2022، وسيستخدمها كمؤشر معياري للتقارير المستقبلية."
    },
    sectionSix : {
        card : {
            image : {
                name : "water-2.jpg",
                alt : "Wonderfull view for shore of rocks and sea",
            }
        },
        info : {
            title : "المياه",
            paragraphOne : "قام البنك بتحديثات واسعة النطاق للبنية التحتية للمياه في جميع فروعه من خلال تركيب الصنابير التي تعمل عند تحريك اليد بدون لمس، وذلك في إطار جهوده لتوفير المياه. كما قام البنك بتركيب أنظمة تقلل من استهلاك المياه لأنظمة المراحيض، والتي تستخدم المياه الجوفية في الغالب.",
            // paragraphTwo : "We also implemented a lower water consumption system in our flushing toilet systems, which mostly use underground water. SAB’s buildings rely solely on water provided by the National Water Company."
        },
        title : "استهلاك المياه",
        labels : [
            [
                {
                    size : '10',
                    subtitle : "2021",
                },
                {
                    size : '40',
                    number : 80784,
                    unit : "متر مكعب"
                },
                {
                    size : '40',
                    subtitle : "إجمالي استهلاك المياه"
                }
            ],
            [
                {
                    size : '10',
                    subtitle : "2021",
                },
                {
                    size : '40',
                    number : 20.71,
                    unit : <span>متر مكعب/موظف</span>
                },
                {
                    size : '40',
                    subtitle : "كثافة استهلاك المياه"
                }
            ],
        ],
        note : "تعتمد مباني بنك الأول فقط على المياه التي توفرها شركة المياه الوطنية."
    }
}

export default emissionsPageDataAr;